import React from 'react';
import { Form, Select, Row, Col, Button } from 'antd';
import {getStoresList, getCategoriesList} from '../../modules/Api';

const FormItem = Form.Item;
const Option = Select.Option;

function hasErrors(fieldsError) {
    return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class PopularForm extends React.Component {
    constructor() {
        super();
        this.state = {
            category_id:false,
            brand_id:false,
            order: false,
            brands: [],
            categories: [],
            filteredStoreKeyword: '',
            filteredCategoryKeyword: '',
        }
    }
    componentDidMount() {
        getStoresList(``, res => {this.setState({brands: res})});
        getCategoriesList(res => {this.setState({categories: res.data.data.data})});
    }

    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, fieldsValue) => {
            if (err) {
                return;
            }
            this.props.submit(fieldsValue);
        });
    }

    render() {
        const brands = this.state.brands.filter(s => s.name.startsWith(this.state.filteredStoreKeyword));
        const categories = this.state.categories.filter(s => s.name.startsWith(this.state.filteredCategoryKeyword));
        
        const formItemLayout = {
            labelCol: {
            xs: { span: 24 },
            sm: { span: 24 },
            },
            wrapperCol: {
            xs: { span: 24 },
            sm: { span: 24 },
            },
        };
        const { getFieldDecorator, getFieldsError } = this.props.form;
        return (
            <div style={{direction: 'rtl'}}>
            <Form onSubmit={this.handleSubmit}>
                <Row>
                    <Col span={10} offset={1}>
                        <FormItem
                        {...formItemLayout}
                        label="فروشگاه"
                        colon={false}>
                            {getFieldDecorator('brand_id', {
                                initialValue: this.props.initialData.brand_id,
                                rules: [
                                { required: true, message: 'فروشگاه را انتخاب نمایید' },
                                ],
                            })(
                                <Select filterOption={false} mode="combobox" placeholder="انتخاب فروشگاه" style={{width: '200px'}} showSearch={true} onChange={k => {this.setState({filteredStoreKeyword: k})}}>
                                    {brands.map(s => <Option value={s.id.toString()} key={`ss__${s.id}`}>{s.name}</Option>)}
                                </Select>
                            )}
                        </FormItem>
                    </Col>
                    <Col span={10} offset={1}>
                        <FormItem
                        {...formItemLayout}
                        label="دسته‌بندی"
                        colon={false}>
                            {getFieldDecorator('category_id', {
                                initialValue: this.props.initialData.category_id,
                                rules: [
                                { required: true, message: 'دسته‌بندی را انتخاب نمایید' },
                                ],
                            })(
                                <Select filterOption={false} mode="combobox" placeholder="انتخاب دسته‌بندی" style={{width: '200px'}} showSearch={true} onChange={k => {this.setState({filteredCategoryKeyword: k})}}>
                                    {categories.map(s => <Option value={s.id.toString()} key={`ss__${s.id}`}>{s.name}</Option>)}
                                </Select>
                            )}
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                <Col span={24}>
                    <FormItem>
                        <Button
                            type="primary"
                            htmlType="submit"
                            disabled={hasErrors(getFieldsError()) || this.props.submitted}
                            style={{width: '10%', margin: '0px 45%'}}>
{this.props.submitted ? 'منتظر بمانید' : ' ثبت'}
                        </Button>
                    </FormItem>
                </Col>
                </Row>  
            </Form>
            </div>
        );
    }
}

PopularForm.defaultProps = {
    initialData: {}
}

export default Form.create()(PopularForm);


// WEBPACK FOOTER //
// ./src/containers/PopularStores/form.js